/**
 * Profile Action Buttons Component
 *
 * Contains Save and Cancel buttons with blue-outlined container
 */

import { Button } from "@/components/ui/button"
import { useTranslation } from "@/language"

interface ProfileActionButtonsProps {
  onSave: () => void
  onCancel: () => void
  isSubmitting?: boolean
}

export function ProfileActionButtons({ onSave, isSubmitting = false }: ProfileActionButtonsProps) {
  const { t } = useTranslation("profile")

  return (
    <div className="rounded-xl p-5 bg-card">
      <div className="flex gap-3 flex-col">
        {/* Save Button */}
        <Button
          type="button"
          variant="secondary"
          size="default"
          onClick={onSave}
          isLoading={isSubmitting}
          disabled={isSubmitting}
          className="flex-1 px-4 py-4 font-semibold h-12 uppercase"
        >
          {t("profileCompletion.save")}
        </Button>
      </div>
    </div>
  )
}
